import api from '@/plugins/axios'

export interface LgpdConsentimento {
    consentimentoDados: boolean
    consentimentoMarketing: boolean
    dataConsentimento?: string
}

class LgpdService {
    private baseUrl = '/lgpd'

    async exportarMeusDados(): Promise<Record<string, unknown>> {
        const { data } = await api.get<Record<string, unknown>>(`${this.baseUrl}/meus-dados`)
        return data
    }

    async exportarMeusDadosXml(): Promise<string> {
        const { data } = await api.get<string>(`${this.baseUrl}/meus-dados`, {
            params: { formato: 'xml' },
            responseType: 'text',
            headers: { 'Accept': 'application/xml' }
        })
        return data
    }

    async solicitarExclusao(): Promise<void> {
        await api.delete(`${this.baseUrl}/meus-dados`)
    }

    async getPoliticaPrivacidade(): Promise<string> {
        const { data } = await api.get<string>(`${this.baseUrl}/politica-privacidade`)
        return data
    }

    async registrarConsentimento(request: { consentimentoDados: boolean; consentimentoMarketing: boolean }): Promise<LgpdConsentimento> {
        const { data } = await api.post<LgpdConsentimento>(`${this.baseUrl}/consentimento`, request)
        return data
    }

    async verificarConsentimento(): Promise<LgpdConsentimento> {
        const { data } = await api.get<LgpdConsentimento>(`${this.baseUrl}/consentimento`)
        return data
    }
}

export default new LgpdService()
